// Components==============
import { faDownload, faTrash } from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/Button/Button';
import { useRedux } from 'hooks/useRedux';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import React, { useEffect, useState } from 'react';
import { EvidenceState } from 'typings';
import { getSmartImage } from 'utilities/getSmartImage';
import CircleButton from '../CircleButton/CircleButton';
import ImageSelector from '../ImageSelector/ImageSelector';
import './ImageManager.module.scss';
// =========================

export default function ImageManager({
  handleDelete,
  deleteCondition = true,
  images,
  initialImage,
  extern,
  current,
  setCurrent,
  setModalIsOpen,
  feedback,
  canDeleteIfUserCreated = true,
}: {
  handleDelete?: (c: EvidenceState) => void;
  deleteCondition?: boolean;
  images: EvidenceState[];
  initialImage?: number;
  setModalIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  extern?: boolean;
  // Only for evidence modal
  current?: number;
  setCurrent?: React.Dispatch<React.SetStateAction<number>>;
  feedback?: (FeedbackEntity | undefined)[];
  canDeleteIfUserCreated?: boolean;
  //
}) {
  const [currentImage, setCurrentImage] = useState(
    images?.[initialImage || 0] || { name: '', path: '' }
  );
  const translate = useTranslate();

  const userId = useRedux((state) => state.authentication?.user?.id);

  const { closeModal } = useRootModal();

  useEffect(() => {
    if (current !== undefined && setCurrent) {
      setCurrent(images.indexOf(currentImage));
    }
  }, [currentImage]);

  const [counter, setCounter] = useState(0);
  useEffect(() => {
    setCounter(1);
    if (counter === 0) return;

    if (images.length) {
      setCurrentImage(images[0]);
      return;
    }

    return setModalIsOpen ? setModalIsOpen(false) : closeModal();
  }, [images.length]);

  const name =
    currentImage.name ||
    currentImage.path.substring(currentImage.path.lastIndexOf('/') + 1) ||
    `- ${translate('general.terms.untitled-document')}`;

  console.log('imageManager', deleteCondition);

  return (
    <div style={{ position: 'relative' }}>
      <div styleName="wrapper">
        {currentImage.path.includes('.mp4') ? (
          <video preload="metadata" controls>
            <source src={`${currentImage?.path}#t=0.5`} type="video/mp4" />
          </video>
        ) : (
          <img
            src={
              extern
                ? `/images/cloud.png`
                : getSmartImage(currentImage.path, currentImage.name)
            }
            alt={currentImage.path}
          />
        )}
        {!!extern && (
          <a
            href={`${!currentImage.path.includes('http') ? '//' : ''}${
              currentImage.path
            }`}
            target="_blank"
            rel="noreferrer"
            styleName="link-button"
          >
            <Button color="white">
              {translate('general.terms.watch-file')}
            </Button>
          </a>
        )}
        <div styleName="overlay">
          <p>
            {!!(currentImage.author && currentImage.author.id !== userId) &&
              `${currentImage.author.first_name} ${currentImage.author.last_name} -`}{' '}
            {name}
          </p>
          <div styleName="icons">
            <a href={currentImage.path} download={name}>
              <CircleButton icon={faDownload} color="white" />
            </a>
            {(canDeleteIfUserCreated || deleteCondition) && handleDelete && (
              <CircleButton
                color="white"
                onClick={() =>
                  handleDelete({
                    name: currentImage.name,
                    path: currentImage.path,
                    evidenceId: currentImage.evidenceId,
                    feedback: feedback?.map((f) => f?.id),
                  })
                }
                icon={faTrash}
              />
            )}
          </div>
        </div>
      </div>
      <div styleName="selector-wrapper">
        <ImageSelector
          images={images.map((i) => ({
            path: i.path,
            name: i.name,
          }))}
          currentImage={currentImage.path}
          setCurrentImage={(path) =>
            // @ts-ignore
            setCurrentImage(images.find((i) => i.path === path))
          }
        />
      </div>
    </div>
  );
}
